import { Grid, Avatar, Paper, Icon } from '@mui/material';

import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { stringToColour } from 'utils';

import { WatchlistAddButton } from 'app/components/WatchlistAddButton';
import { translations } from 'locales/i18n';

interface Props {
  listing: any;
}

export default function ListingSideInfo({ listing }: Props): ReactElement {
  const { t } = useTranslation();
  const [avatarBackground, color] = stringToColour(listing.author.id);
  return (
    <>
      <Grid item className="listing-detail__author">
        <WatchlistAddButton
          categoryName="BULLETIN"
          description={listing.offerText}
          title={listing.title}
          variant="contained"
          size="small"
          date={listing.startDate}
        />
        <Grid container className="listing-detail__author__heading">
          {t(translations.pages.listingDetail.postedBy())}
        </Grid>
        <Grid container>
          <Grid item xs="auto">
            <Avatar
              className="listing-detail__author__avatar"
              variant="rounded"
              style={{
                backgroundColor: avatarBackground,
                color
              }}
            >
              {`
                  ${listing.author.firstName.charAt(0).toUpperCase()}${listing.author.lastName
                .charAt(0)
                .toUpperCase()}
                `}
            </Avatar>
          </Grid>
          <Grid item xs>
            <Grid container className="listing-detail__author__name">
              {`${listing.author.firstName} ${listing.author.lastName}`}
            </Grid>

            <Grid container className="listing-detail__author__date">
              {t(translations.pages.listingDetail.postedOn(), {
                date: new Date(listing.startDate).toLocaleDateString()
              })}
            </Grid>
          </Grid>
        </Grid>
        <a href={`mailto:${listing.email}`}>
          <Grid container component={Paper} className="listing-detail__author__standout">
            <Grid item xs="auto">
              <Icon className="fas fa-at" />
            </Grid>
            <Grid item xs className="listing-detail__author__standout__text">
              {listing.email}
            </Grid>
          </Grid>
        </a>
        {listing.phone && (
          <Grid container component={Paper} className="listing-detail__author__standout">
            <Grid item xs="auto">
              <Icon className="fas fa-phone" />
            </Grid>
            <Grid item xs className="listing-detail__author__standout__text">
              {listing.phone}
            </Grid>
          </Grid>
        )}
        {listing.address && (
          <Grid container component={Paper} className="listing-detail__author__standout">
            <Grid item xs="auto">
              <Icon className="fas fa-map-marker-alt" />
            </Grid>
            <Grid item xs className="listing-detail__author__standout__text">
              {listing.address}
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}
